import React from 'react';
import {
  Container,
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
} from '@mui/material';
import {
  Forum as ForumIcon,
  Group as GroupIcon,
  QuestionAnswer as QuestionIcon,
} from '@mui/icons-material';

const Community = () => {
  const sections = [
    {
      title: 'Discussion Forums',
      description: 'Join conversations about LSAT Logical Reasoning strategies and tips.',
      icon: <ForumIcon sx={{ fontSize: 40, color: '#4F46E5' }} />,
      action: 'Browse Forums',
    },
    {
      title: 'Study Groups',
      description: 'Find or create study groups to practice with other LSAT students.',
      icon: <GroupIcon sx={{ fontSize: 40, color: '#4F46E5' }} />,
      action: 'Find Groups',
    },
    {
      title: 'Q&A Section',
      description: 'Ask questions and get help from the community.',
      icon: <QuestionIcon sx={{ fontSize: 40, color: '#4F46E5' }} />,
      action: 'Ask a Question',
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Community
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Connect with fellow LSAT students, share experiences, and learn together.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {sections.map((section, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Box sx={{ textAlign: 'center', mb: 2 }}>
                  {section.icon}
                </Box>
                <Typography variant="h6" gutterBottom align="center">
                  {section.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph align="center">
                  {section.description}
                </Typography>
                <Box sx={{ textAlign: 'center' }}>
                  <Button
                    variant="contained"
                    sx={{
                      bgcolor: '#4F46E5',
                      '&:hover': {
                        bgcolor: '#3730A3',
                      }
                    }}
                  >
                    {section.action}
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Paper sx={{ mt: 4, p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Coming Soon
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Chip label="Live Study Sessions" />
          <Chip label="Mentor Matching" />
          <Chip label="Practice Partners" />
          <Chip label="Resource Sharing" />
        </Box>
      </Paper>
    </Container>
  );
};

export default Community; 